import React from "react";
import { useTranslation } from "react-i18next";
import * as S from "./styled";

export const MembersSection = ({ activeMembers, pendingMembers, isOwner, onRemoveMember, isDemo = false }) => {
  const { t } = useTranslation();
  return (
  <>
    <S.MembersList>
      {activeMembers.map((member) => (
        <S.MemberCard key={member.email}>
          <S.MemberAvatar $isOwner={member.role === "owner"}>
            {member.displayName?.charAt(0).toUpperCase() || "?"}
          </S.MemberAvatar>
          <S.MemberInfo>
            <S.MemberName>{member.displayName}</S.MemberName>
            <S.MemberEmail>{member.email}</S.MemberEmail>
          </S.MemberInfo>
          {member.role === "owner" && <S.OwnerBadge>{t("family.owner")}</S.OwnerBadge>}
          {isOwner && member.role !== "owner" && (
            <S.RemoveButton onClick={() => onRemoveMember(member.email)}>✕</S.RemoveButton>
          )}
        </S.MemberCard>
      ))}
    </S.MembersList>
    {pendingMembers.length > 0 && (
      <>
        <S.PendingDivider>{t("family.pendingInvitations")}</S.PendingDivider>
        {pendingMembers.map((member) => (
          <S.PendingCard key={member.email}>
            <S.PendingIcon />
            <S.PendingEmail>{member.email}</S.PendingEmail>
            {isOwner && !isDemo && (
              <S.RemoveButton onClick={() => onRemoveMember(member.email)}>✕</S.RemoveButton>
            )}
          </S.PendingCard>
        ))}
      </>
    )}
  </>
  );
};
